import React from "react";
import AppointmentTab from "./AppointmentTab";
import Box from '@mui/material/Box';
import Tabs from './Tabs';
import useDebugInformation from "../../../../../../hooks/useDebugInformation";
import ToggleButtonsGroup from "../../../../../Shared/ToggleButtonsGroup";
import { useAppSelector } from "@store/hooks";

const name = "StepTwoForm"

const values = ["date", "contact", "address"]

type Props = {
  parent: string
}

const StepTwoForm: React.FC<Props> = ({ parent }) => {
  const debugName = `${parent}▷[${name}]`

  const stepTwoActiveTab = useAppSelector(({ ui }) => ui.StepTwoActiveTab)
  useDebugInformation(debugName, { stepTwoActiveTab })
  return (
    <Box sx={{ '& input': { height: '1em' } }}>
      <ToggleButtonsGroup values={values} groupName="StepTwoActiveTab" step={2} />
      {stepTwoActiveTab === "date" && <AppointmentTab parent={debugName} />}
      {stepTwoActiveTab === "contact" && <Tabs parent={debugName} affix="Contact" />}
      {stepTwoActiveTab === "address" && <Tabs parent={debugName} affix="Address" />}
    </Box>
  );
}


export default React.memo(StepTwoForm)
